import React, { useCallback } from "react";
import { Pressable, StyleSheet } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { router } from "expo-router";
import { Image } from "expo-image";

import UserNotificationBaseItem from "./UserNotificationBaseItem";

import type {
  UserNotification,
  UserNotificationFollowingImageUploadData,
} from "@/schemas/user/notification";
import type { UserLikableImageMedia } from "@/schemas/user/image";

type Props = {
  userNotification: UserNotification;
  handleMarkNotificationAsRead: () => void;
};

function UserNotificationFollowingImageUploadItem({
  userNotification,
  handleMarkNotificationAsRead,
}: Props): React.JSX.Element {
  const notificationData =
    userNotification.data as UserNotificationFollowingImageUploadData;
  const profilePreview = notificationData.followingImageUpload.uploadedBy;
  const uploadedImage = notificationData.followingImageUpload.uploadedImage;

  const handleImagePreviewPress = async (
    imageMedia: UserLikableImageMedia,
  ): Promise<void> => {
    router.push({
      params: { imageMedia: JSON.stringify(imageMedia) },
      pathname: "/(main)/shared/image",
    });
  };

  const renderRightComponent = useCallback(
    (markAsRead: () => void): React.JSX.Element => {
      return (
        <Pressable
          onPress={() => {
            markAsRead();
            handleImagePreviewPress(uploadedImage);
          }}
        >
          <Image
            source={{ uri: uploadedImage.image.attributes.previewUrl }}
            style={styles.image}
            contentFit="cover"
            cachePolicy="memory-disk"
          />
        </Pressable>
      );
    },
    [uploadedImage],
  );

  return (
    <UserNotificationBaseItem
      renderRightComponent={renderRightComponent}
      userNotification={userNotification}
      profile={profilePreview}
      handleMarkNotificationAsRead={handleMarkNotificationAsRead}
      notificationTypeIconComponent={
        <MaterialCommunityIcons
          name="file-image-plus-outline"
          size={17}
          color="black"
        />
      }
      notificationDescription={"added a new photo"}
    />
  );
}

const styles = StyleSheet.create({
  image: {
    width: 60,
    height: 60,
    borderRadius: 8,
  },
});

export default UserNotificationFollowingImageUploadItem;
